const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    // Try the modern API first
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    // Fallback for Safari
    const textarea: HTMLTextAreaElement = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);
    textarea.select();

    try {
      const success: boolean = document.execCommand('copy');
      textarea.remove();
      return success;
    } catch (err) {
      console.error('Failed to copy text:', err);
      textarea.remove();
      return false;
    }
  }
};

export default copyToClipboard;
